<template>
  <c-body v-show="dataLoaded">
    <header class="toolbar">
      <c-note v-if="clientStatus === 'SUSPENDED'" class="u-text-center" style="margin-bottom: 16px" type="danger">CONTUL ESTE SUSPENDAT PENTRU
        NEPLATA
      </c-note>
      <c-note v-if="clientStatus === 'INACTIVE'" class="u-text-center" style="margin-bottom: 16px" type="danger">CONTUL ESTE DEZACTIVAT</c-note>
      <div class="l-container">
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <h1 class="toolbar__title">Documents</h1>
            </template>
          </c-level>
        </div>
        <!-- END .toolbar__group -->
        <div class="toolbar__group">
          <c-level>
            <template slot="left">
              <c-nav type="pills">
                <c-nav-item :active="active[0]" title="Unread" @click="onFilter(0)"></c-nav-item>
                <c-nav-item :active="active[1]" title="All" @click="onFilter(1)"></c-nav-item>
                <c-nav-item :active="active[2]" title="Not Processed" @click="onFilter(2)"></c-nav-item>
                <c-nav-item :active="active[3]" title="Processed" @click="onFilter(3)"></c-nav-item>
                <c-nav-item :active="active[4]" title="Errors" @click="onFilter(4)"></c-nav-item>
              </c-nav>
            </template>
            <template slot="right">
              <c-form layout="inline">
                <c-form-field>
                  <c-form-group>
                    <c-form-input v-model="searchText" :clearable=true placeholder="search for text"/>
                    <date-picker v-model="startDate" lang="en" width="80"></date-picker>
                    <c-form-addon>-</c-form-addon>
                    <date-picker v-model="endDate" lang="en" width="80"></date-picker>
                  </c-form-group>
                </c-form-field>
              </c-form>
            </template>
          </c-level>
        </div>
        <!-- END .toolbar__group -->
      </div>
    </header>
    <div class="l-container">
      <c-row>
        <c-col md>
          <c-panel>
            <c-stack row>
              <template slot="start">
                <c-pagination :pager="true" :total="total" :value="page" size="sm" @input="selectPage"/>
              </template>
              <template slot="end">
                <c-button @click="forceRefresh"><i class="icon-spinner9 u-color-success"></i></c-button>
              </template>
            </c-stack>
            <ul class="list list--sm">
              <DocumentRow v-for="r in data" v-bind:key="r.id+r.status.toString()" :request="r"></DocumentRow>
            </ul>
          </c-panel>
        </c-col>
        <c-col v-if="clientStatus === 'ACTIVE'" md=8>
          <Batches></Batches>
          <c-panel>
            <Upload></Upload>
          </c-panel>
        </c-col>
      </c-row>
    </div>
  </c-body>
</template>
<script>
/*
date picker component: https://www.npmjs.com/package/vue2-datepicker
*/

import Upload from './Upload'
import DocumentRow from './DocumentRow'

import DatePicker from '../vue2-datepicker'
import axios from 'axios'
import moment from 'moment'
import {mapState, mapActions} from 'vuex'
import Batches from './Batches/Batches'

export default {
  name: 'UserDocuments',
  components: {
    Batches,
    Upload,
    DatePicker,
    DocumentRow
  },

  computed: {
    ...mapState('auth', ['clientCode', 'clientId', 'clientStatus'])
  },

  data () {
    return {
      startDate: new Date(),
      endDate: new Date(),
      searchText: null,
      data: [],
      fullData: [],
      total: 0,
      page: 0,
      pageSize: 15,
      active: [true, false, false, false, false],
      queries: ['/results/unread', '/results/all', '/results/pending', '/results/processed', '/results/errors'],
      activeFilter: 0,
      lastQuery: '',
      tf: null,
      dataLoaded: false
    }
  },

  created () {
    let d = moment()
    let d1 = moment([d.year(), d.month(), d.date()])
    let d2 = d1.clone()
    this.endDate = d2
    this.startDate = d1
    this.retrieveClientRequestProperties(this.clientCode).then(() => {
      this.dataLoaded = true
      this.refreshData()
    }).catch(_ => {
      this.dataLoaded = true
    })
  },

  mounted () {
    // this.refreshData()
  },

  watch: {
    startDate: function (oldDate, newDate) {
      this.refreshData()
    },
    endDate: function (oldDate, newDate) {
      this.refreshData()
    },
    searchText: function (oldText, newText) {
      this.searchForText()
    }

  },

  methods: {
    ...mapActions('client', ['retrieveClientRequestProperties']),
    refreshData () {
      if (this.tf != null) {
        clearTimeout(this.tf)
      }
      let url = process.env.API + this.clientCode + this.queries[this.activeFilter]
      let d1 = moment(this.startDate)
      let d2 = moment(this.endDate)
      d2.add(1, 'd')
      d1.utc()
      d2.utc()
      url += '?startDate=' + d1.toJSON() + '&endDate=' + d2.toJSON()
      if (this.searchText != null && this.searchText.trim() !== '') {
        url += '&search=' + encodeURI(this.searchText)
      }
      this.getData(url)
    },

    searchForText () {
      if (this.tf != null) {
        clearTimeout(this.tf)
      }
      this.tf = setTimeout(this.refreshData, 500)
    },

    forceRefresh () {
      let q = this.lastQuery
      this.lastQuery = ''
      this.getData(q)
    },

    getData (url) {
      if (this.lastQuery === url) return
      this.lastQuery = url

      axios.get(url).then((response) => {
        this.handleData(response.data)
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
      })
    },

    selectPage (page) {
      console.log('selectPage ' + page.toString())
      this.page = page
      this.data = this.fullData.slice((page - 1) * this.pageSize, page * this.pageSize)
    },

    handleData (data) {
      this.total = Math.ceil(data.length * 1.0 / this.pageSize)
      this.fullData = data
      this.page = 1
      this.selectPage(1)
    },

    onFilter (position) {
      console.log('filter ' + position)
      if (this.active[position]) {
        return
      }

      this.activeFilter = position
      let items = [false, false, false, false, false]
      items[position] = true
      this.active = items

      this.refreshData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserDocuments.vue